import React from 'react';

function ContactHero() {
  return (
    <section 
      className="services-hero contact-hero" 
      style={{ backgroundImage: "url('/assets/images/contact-hero-bg.webp')" }}
    >
      {/* Overlay to dim background */}
      <div className="services-hero-overlay"></div>

      {/* Hero Content */}
      <div className="container services-hero-container">
        <div className="services-hero-content">
          <div className="services-hero-tagline-row">
            <span className="services-hero-tagline">Contact Us</span>
            <div className="services-hero-tagline-line"></div>
          </div>
          <h1 className="services-hero-title">
            Let's Talk About Your Project & Growth
          </h1>
          <p className="services-hero-description">
            Get in touch with our team of experts to discuss your business goals, technological needs, or custom BPO and IT solutions. We're here to help you scale.
          </p>
        </div>
      </div>
    </section>
  );
}

export default ContactHero;
